import React from "react";

// Renders a formatted citation from formatReference() output: italic segments
// via <em>, followed by a clickable DOI/URL. Used by the editor preview and the
// public reference page so formatting is identical everywhere.
export function CitationText({ parts, link, linkLabel, linkPrefix = "", linkSuffix = "", linkClassName = "" }) {
  // Trim trailing whitespace from the last segment so we don't get a double space before the link.
  const segs = parts.slice();
  if (link && segs.length) {
    const last = segs[segs.length - 1];
    segs[segs.length - 1] = { ...last, t: (last.t || "").replace(/\s+$/, "") };
  }
  return (
    <>
      {segs.map((seg, i) =>
        seg.i ? <em key={i}>{seg.t}</em> : <span key={i}>{seg.t}</span>
      )}
      {link && (
        <>
          {" "}
          {linkPrefix && <span>{linkPrefix}</span>}
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={linkClassName || "break-all font-medium text-[#0D9488] underline hover:text-[#0F766E]"}
          >
            {linkLabel}
          </a>
          {linkSuffix && <span>{linkSuffix}</span>}
        </>
      )}
    </>
  );
}
